import * as React from 'react';
import * as styles from '../styles.scss';
import { AccountDropdown, Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import * as globalStyles from 'styles/style.scss';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { formatNumber, handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import { IAccount } from 'interfaces/common';
import CurrentPriceField from '../CurrentPriceField';
import { FormikErrors } from 'formik';
import { OrderType } from 'constants/enum';

interface IAccountSectionProps
  extends React.ClassAttributes<AccountComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly isHorizontal: boolean;
  readonly buyType: boolean;
  readonly purchasingPower?: number;
  readonly values: IOrderForm;
  readonly sellType: boolean;
  readonly marginRatio?: number;
  readonly marginPriceCap?: number;

  readonly onChangeAccount: (accountNumber?: IAccount) => void;
  readonly onClickPrice: (price?: number) => void;
  readonly onChangeOrderType: (orderType: OrderType, orderQtt: number) => void;

  readonly onChangeQuantity: (
    quantity?: number,
    orderQuantityType?: 'share' | 'amount' | 'percentage',
    orderQuantityPercentage?: number
  ) => void;

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class AccountComponent extends React.Component<IAccountSectionProps> {
  render() {
    const {
      t,
      config,
      isHorizontal,
      onChangeAccount,
      buyType,
      purchasingPower,
      values,
      sellType,
      onClickPrice,
      marginPriceCap,
      marginRatio,
      ErrorMessage,
      errors,
    } = this.props;
    const maxQty =
      values.orderType === OrderType.ODDLOT && buyType
        ? values.orderPrice && values.orderPrice > 0
          ? Math.floor((purchasingPower ?? 0) / values.orderPrice)
          : 0
        : values.maxQty;
    return (
      <>
        {config[OrderFormFieldKey.ACCOUNT] != null && (
          <div
            className={classNames(styles.AccountSection, styles.FormField)}
            style={config[OrderFormFieldKey.ACCOUNT]?.style}
          >
            <div className={classNames(styles.MainField)}>
              <div className={styles.FieldTitle}>{t('Account No.')}</div>
              <div
                className={classNames(styles.FieldInput, {
                  [styles.Vertical]: !isHorizontal,
                })}
              >
                <AccountDropdown isForm={true} onChange={onChangeAccount} />
              </div>
            </div>
            <div className={classNames(styles.MainField)}>
              <div className={styles.FieldTitle}>
                {buyType ? t('PP') : t('PP1')}
              </div>
              <div
                className={classNames(styles.FieldInput, {
                  [styles.Vertical]: !isHorizontal,
                })}
              >
                {buyType ? (
                  <div className={classNames(styles.FieldInfo, styles.PP)}>
                    {` ${formatNumber(
                      purchasingPower,
                      undefined,
                      undefined,
                      undefined,
                      '--'
                    )} VNĐ `}
                    {`${'('}`}
                    <span
                      onClick={() => {
                        this.onClickMaxQty(maxQty ?? 0);
                      }}
                      className={classNames(
                        {
                          [globalStyles.Up]: maxQty != null,
                        },
                        styles.MaxQty
                      )}
                    >
                      {formatNumber(
                        maxQty,
                        undefined,
                        undefined,
                        undefined,
                        '--'
                      )}
                    </span>
                    {`${')'}`}
                  </div>
                ) : sellType ? (
                  <div className={classNames(styles.FieldInfo, styles.PP)}>
                    <span
                      onClick={() => {
                        this.onClickMaxQty(maxQty ?? 0);
                      }}
                      className={classNames(
                        {
                          [globalStyles.Down]: values.maxQty != null,
                        },
                        styles.MaxQty
                      )}
                    >
                      {formatNumber(
                        values.maxQty,
                        undefined,
                        undefined,
                        undefined,
                        '--'
                      )}
                    </span>
                  </div>
                ) : (
                  '__'
                )}
              </div>
            </div>
            {isHorizontal && (
              <div>
                <div
                  style={
                    (config[OrderFormFieldKey.CURRENT_PRICE]?.style,
                    { height: '100%' })
                  }
                >
                  <CurrentPriceField onClickPrice={onClickPrice} />
                </div>
                <div className={styles.MarginInfo}>
                  <div
                    className={classNames(styles.FieldInfo, {
                      [styles.Ratio]: !isHorizontal,
                    })}
                    style={config[OrderFormFieldKey.MARGIN_RATIO]?.style}
                  >
                    {`${t('Margin1')}: `}
                    <span style={{ color: 'white' }}>
                      {marginRatio ?? '--'}%
                    </span>
                  </div>
                  <div
                    className={classNames(styles.FieldInfo, {
                      [styles.Ratio]: !isHorizontal,
                    })}
                    style={
                      (config[OrderFormFieldKey.MARGIN_RATIO]?.style,
                      { textAlign: 'right' })
                    }
                  >
                    {` ${t('Block Price')}: `}
                    <span style={{ color: 'white' }}>
                      {formatNumber(
                        marginPriceCap,
                        undefined,
                        undefined,
                        undefined,
                        '--'
                      )}{' '}
                      VNĐ
                    </span>
                  </div>
                </div>
              </div>
            )}
            <ErrorMessage message={errors.accountNumber} />
          </div>
        )}
      </>
    );
  }
  private onClickMaxQty = (maxQty: number) => {
    this.props.onChangeQuantity(maxQty, 'share');
    maxQty &&
      maxQty <= 99 &&
      this.props.onChangeOrderType(OrderType.ODDLOT, maxQty);
  };
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const AccountSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(AccountComponent)
  ),
  Fallback,
  handleError
);

export default AccountSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/Account.tsx